
import { LoadProfile,LoadDecision, LoadUsersList, LoadCustomersList, UserDeleteService, UpdateUserService, UpdateCustomerService, CustomerDeleteService } from '../../services/ProfileServices';
import * as ActionTypes from '../ActionTypes';


export const LoadProfileAction = () => {
    return (dispatch) => {

        dispatch({ type: ActionTypes.LOADING });

        LoadProfile().then((res) => {

            if (res.hasOwnProperty('success') && res.success === true) {
                dispatch({ type: ActionTypes.LOAD_PROFILE_SUCCESS, res });
            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.LOAD_PROFILE_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}

export const LoadProfileActionDisplay = (setProfileDisplay, setCompanyDisplay, setDisableEdit, setShowPanelLicense, setIndividual) => {
    return (dispatch) => {
        
        dispatch({type: ActionTypes.LOADING});

        LoadProfile().then((res) => {
             
            if(res.hasOwnProperty('success') && res.success === true){
                if (res.user.role_users_id == 3 || res.user.role_users_id == 4) {
                    setDisableEdit(false);
                    setProfileDisplay(true);
                    if (res.user.role_users_id == 4) {
                        setCompanyDisplay(true)
                    }
                    if (res.user.role_users_id == 3){
                        setIndividual(true);
                    }
                    if (res.user.is_active == 1 && res.user.role_users_id == 3) {
                        setShowPanelLicense(true)
                        
                    }
                   
                } else {
                    setProfileDisplay(false);
                    setCompanyDisplay(true)
                }
                dispatch({type: ActionTypes.LOAD_PROFILE_SUCCESS,res});
               
                
            }else if(res.hasOwnProperty('success') && res.success === false){
                dispatch({type: ActionTypes.LOAD_PROFILE_ERROR,res});
            }
            
        }, error => {
            dispatch({type : ActionTypes.CODE_ERROR, error})
        })
    }
}


export const DecisionUserAction = (signal) => {
    return (dispatch) => {

        //dispatch({ type: ActionTypes.LOADING });

        LoadDecision(signal).then((res) => {

            if (res.hasOwnProperty('success') && res.success === true) {
                 
                dispatch({ type: ActionTypes.LOAD_PROFILE_SUCCESS, res });
              
            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.LOAD_PROFILE_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}
export const LoadUsersListAction = (setRestrictedResponse, setRestrictedStatus, setRows, setRolesConfig, signal) => {
    return (dispatch) => {
        
        dispatch({type: ActionTypes.LOADING});

        LoadUsersList(signal).then((res) => {
            if(res.hasOwnProperty('success') && res.success === true && !res.message.localeCompare("List of Users")){
                
                setRows(res.data);
                setRolesConfig(res.roles)
                dispatch({type: ActionTypes.LOAD_USERS_LIST_SUCCESS,res});
          

            }else if(res.hasOwnProperty('success') && res.success === false){
                if (res.success === false && Object.keys(res.message).includes('authorization_error')) {
                    setRestrictedResponse(res);
                    setRestrictedStatus(true);
                }
                dispatch({type: ActionTypes.LOAD_USERS_LIST_ERROR,res});
                

            }
            
        }, error => {
            dispatch({type : ActionTypes.CODE_ERROR, error})
        })
    }
}
export const LoadCustomersListAction = (setRows, setRestrictedResponse, setRestrictedStatus, setBodyStatus, signal, setCustomerEditFlag) => {
  
    return (dispatch) => {
        dispatch({ type: ActionTypes.LOADING });

        LoadCustomersList(signal).then((res) => {
            if (res.hasOwnProperty('success') && res.success === true && !res.message.localeCompare("List of Users")) {
                let users = res.data;
                users.map(
                    (user) => {
                        user.is_active = (user.is_active == null || user.is_active == 0) ? "Inactive" : "Active";

                    })
                setCustomerEditFlag(res.customer_edit)
                setRows(users); 
                setBodyStatus(true);
                dispatch({ type: ActionTypes.LOAD_USERS_LIST_SUCCESS, res });
              
            } else if (res.hasOwnProperty('success') && res.success === false) {
                if (res.success === false && Object.keys(res.message).includes('authorization_error')) {
                    setRestrictedResponse(res);
                    setRestrictedStatus(true);
                }
                dispatch({ type: ActionTypes.LOAD_USERS_LIST_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}


export const UserDeleteAction = (credentials, history,setRefresh) => {
    return (dispatch) => {
        //dispatch({type: ActionTypes.RESTART_AUTH_RESPONSE});
        dispatch({type: ActionTypes.LOADING});
        
      

        UserDeleteService(credentials).then((res) => {
            if(res.hasOwnProperty('success') && res.success === true){
                history.push('/users-list');
                setRefresh(true);
                dispatch({type: ActionTypes.USER_DELETE_SUCCESS,res});
              

            }else if(res.hasOwnProperty('success') && res.success === false){
                
                dispatch({type: ActionTypes.USER_DELETE_ERROR,res});
            }
            
        }, error => {
            dispatch({type : ActionTypes.CODE_ERROR, error})
        })

        
    }
}
export const CustomerDeleteAction = (credentials, history) => {
    return (dispatch) => {
        //dispatch({type: ActionTypes.RESTART_AUTH_RESPONSE});
        dispatch({ type: ActionTypes.LOADING });
      


        CustomerDeleteService(credentials).then((res) => {
            if (res.hasOwnProperty('success') && res.success === true) {

                dispatch({ type: ActionTypes.USER_DELETE_SUCCESS, res });


            } else if (res.hasOwnProperty('success') && res.success === false) {

                dispatch({ type: ActionTypes.USER_DELETE_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })


    }
}
export const UpdateUserAction = (credentials, setRestrictedResponse,
    setRestrictedStatus, setRows, setRolesConfig, setRunStatus, setState,setBtnSubmitDisabled) => {
    return (dispatch) => {
        dispatch({type: ActionTypes.LOADING});

        

        UpdateUserService(credentials).then((res) => {
            if(res.hasOwnProperty('success') && res.success === true){
                setRunStatus(true);
                dispatch({type: ActionTypes.UPDATE_USER_SUCCESS, res});
                setState({
                    ...credentials, changeStatus: false, fieldStatus: true
                });
            }else if(res.hasOwnProperty('success') && res.success === false){
                setRunStatus(false);
                setRestrictedResponse(res)
                
                dispatch({type: ActionTypes.UPDATE_USER_ERROR,res});
                setState({
                    ...credentials, changeStatus: false,
                    fieldStatus: true,
                });
               
                // setRestrictedStatus(true)
            }
            setBtnSubmitDisabled(false)
            
        }, error => {
            dispatch({type : ActionTypes.CODE_ERROR, error})
        })
    }
}
export const UpdateCustomerAction = (credentials,setState) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.LOADING });



        UpdateCustomerService(credentials).then((res) => {

            if (res.hasOwnProperty('success') && res.success === true) {

                dispatch({ type: ActionTypes.UPDATE_USER_SUCCESS, res });
                setState({
                    ...credentials, changeStatus: false, fieldStatus: true
                });
               
            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.UPDATE_USER_ERROR, res });
                setState({
                    ...credentials, changeStatus: false, fieldStatus: true
                });
            }
           

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}